/**
 * @desc 创建竞拍
 */
import { AuctionEntity, AuctionForm } from '@eastcoal/api/trade/interface'
import { apiFetch } from '@eastcoal/common/utils/fetcher/api'
import {
  RequestOptions,
  ApiConfig
} from '@eastcoal/common/utils/fetcher/interface'

export type CreateAuctionParameter = AuctionForm

const method = 'POST'
const url = '/trade/member/auction/create'

export const createAuctionApi = (
  data?: CreateAuctionParameter,
  config?: Partial<RequestOptions<ApiConfig>>
) => {
  return apiFetch<AuctionEntity>({
    method,
    url,
    data,
    ...config
  })
}

createAuctionApi.method = method
createAuctionApi.url = url
